<template>
  <v-flex xs12>
    <v-card>
      <v-flex xs12 px-4 pt-4 v-if="err">
        <v-alert :value="true" type="error">{{err}}</v-alert>
      </v-flex>
      <v-flex xs12 pa-4 v-if="success">
        <v-alert :value="true" type="success">{{success}}</v-alert>
      </v-flex>
      <v-card-title class="pb-3 px-2 layout row wrap">
        <v-btn
          class="primary my-0 mx-3"
          @click="$router.push({ name: 'createCompany' })">
          {{$lang.actions.createCompany}}
        </v-btn>
        <v-checkbox
          color="primary"
          class="mx-1 mt-0"
          :label="$lang.labels.showActive"
          v-model="showActive"
          hide-details
        />
        <v-spacer/>
        <v-text-field
          class="min-w max-w mx-3 pb-2"
          v-model="search"
          append-icon="search"
          :label="$lang.labels.search"
          hide-details
        />
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="showActive ? activeCompanies : allCompanies"
        :search="search"
        :loading="allCompanies.length === 0"
        :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
      >
        <v-progress-linear height="6" slot="progress" color="primary" indeterminate/>
        <template slot="items" slot-scope="props">
          <td class="min-w">{{props.item.name}}</td>
          <td>{{props.item.postalCode}}</td>
          <td>{{props.item.id}}</td>
          <td>{{props.item.currency}}</td>
          <td>{{props.item.companyStatus}}</td>
          <td class="min-w-lg">
            <v-btn class="primary mx-0 elevation-1" @click="editCompany(props.item)">{{$lang.actions.edit}}</v-btn>
            <v-btn
              class="primary elevation-1"
              @click="changeStatus(props.item)">
              {{props.item.companyStatus === 'active' ? $lang.actions.deactivate : $lang.actions.activate}}
            </v-btn>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" type="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
    <v-dialog v-if="confirmationModal" v-model="confirmationModal" max-width="500">
      <confirmation-modal :data="confirmationData" @close="confirmationModal = false" @change="deactivate($event)"/>
    </v-dialog>
  </v-flex>
</template>

<script>
  import {baseUrl} from '../../assets/url';

  export default {
    components: {
      confirmationModal: () => import('../modals/DeactivationModal'),
    },
    data() {
      return {
        err: '',
        success: '',
        search: '',
        headers: [
          { text: this.$lang.labels.name, value: 'name', align: 'left' },
          { text: this.$lang.labels.postalcode, value: 'postalCode', align: 'left' },
          { text: this.$lang.labels.companyId, value: 'id', align: 'left' },
          { text: this.$lang.labels.currency, value: 'currency', align: 'left' },
          { text: this.$lang.labels.status, value: 'companyStatus', align: 'left' },
          { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false },
        ],
        language: this.$cookie.get('lang') || 'en',
        showActive: true,
        allCompanies: [],
        confirmationModal: false,
        confirmationData: {
          id: null,
          url: 'company',
        },
      };
    },
    computed: {
      activeCompanies() {
        const companies = this.allCompanies;
        const activeCompanies = [];
        for (let i=0; companies.length > i; i++) {
          if (companies[i].companyStatus === 'active') {
            activeCompanies.push(companies[i]);
          }
        }
        return activeCompanies;
      },
    },
    methods: {
      editCompany(company) {
        this.$router.push({ name: 'editCompany', params: {id: company.id }});
      },
      changeStatus(company) {
        if (company.companyStatus === 'inactive') {
          this.$http.post(`company/activate/${company.id}`)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.$set(company, 'companyStatus', 'active');
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
        } else if (company.companyStatus === "active") {
          this.confirmationData.id = company.id;
          this.confirmationModal = true;
        }
      },
      deactivate(id) {
        const result = this.allCompanies.find( data => data.id === id );
        this.$set(result, 'companyStatus', 'inactive');
      },
    },

    created() {
      // Get company list
      this.$http.get('company?detailed=true')
        .then((res) => {
          if (res.body.status === 'Success') {
            this.allCompanies = res.body.companies;
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
    },

    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Companies.vue?36ca05c5